














































































































































































































































































































































































































































































































































































































































































































































































































import {Watch, Component, Vue} from 'vue-property-decorator'
import {Meta} from '@sophosoft/vue-meta-decorator'
import {namespace} from 'vuex-class'
import {TableItem, TableHeaderItem} from '@/utils/types'
import {Survey} from '@/store/modules/lib'
import {uuid} from 'vue-uuid';

import QuestionBox from './QuestionBox.vue'
import QuestionBoxList, {IDraggableParamsExtend} from './QuestionBoxList.vue'
import DetailSideBar from './Details/DetailSideBar.vue'
import LfsRadioBox from './Details/LfsRadioBox.vue'
import Chip from '@/components/UI/Chip.vue'
import draggable from 'vuedraggable'

import IQuestion from '@/models/IQuestion'
import IAnswer from '@/models/IAnswer'
import ITrash from '@/components/icons/ITrash.vue'
import {EventBus} from '@/event-bus'
import {TranslateResult} from 'vue-i18n'
import {NavigationGuardNext, RawLocation, Route} from 'vue-router'
import ISurvey from '@/components/icons/ISurvey.vue';
import PostSignature from '@/components/lfs/Survey/PostSignature.vue';
import Tooltip from '@/components/UI/Tooltip.vue';


interface IQuestionBranchData {
  questionId: string
  answerId: string
  includeQuestions: string[]
}

interface PostModel {
  title:string,
  text: string,
  active?: boolean
}

interface Comment {
  title: string,
  text: string,
  order?: number | null
}

const auth = namespace('auth')
const surv = namespace('survey')
const appStore = namespace('app')
const roistat = namespace('roistat')
const profile = namespace("profile")

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

@Component({
  name: 'Page',
  components: {
    PostSignature,
    LfsRadioBox,
    QuestionBox,
    QuestionBoxList,
    DetailSideBar,
    'c-chip': Chip,
    draggable,
    'i-trash': ITrash,
    Tooltip
  }
})
export default class SurveyPage extends Vue {
  dropdownMenuState: boolean = false
  @appStore.Getter('GetScrollHeight') protected GetScrollHeight: any
  @surv.Action('load') getSurveys: any;
  @surv.Action('deleteQuestion') dltQuestion: any;
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any

  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - ${this.$t('survey.title')}`
    };
  }

  protected stateDeleteDialog: boolean = false;
  protected important: boolean = false;
  protected checkFree: boolean = false;
  protected items: any =[
      { id: 'free_text_input', text: this.$t('survey.data.text') },
      { id: 'free_number_input', text: this.$t('survey.data.number') }
    ]
  protected checkFreeType: string | undefined = 'free_text_input'

  protected deleteWithoutConfirm: boolean = false;
  private deletingItem: TableItem | null = null;

  protected tryDelete(item: TableItem) {
    if (this.deleteWithoutConfirm) {
      if (this.dropAnswer) {
        this.dropAnswer(item);
      }
    }
    else {
      this.deletingItem = item;
      this.stateDeleteDialog = true;
    }
  }

  private deleteYes() {
    this.stateDeleteDialog = false;
    if (this.dropAnswer && this.deletingItem)
      this.dropAnswer(this.deletingItem);
  }
  private deleteNo() {
    this.stateDeleteDialog = false;
    this.deletingItem = null;
  }

  protected changedTypeFree(val: string) {
    this.checkFreeType = val
  }

  protected navigationPath: string = ''
  private selectedQuestion: IQuestion | {} = {}

  protected pageLoading: boolean = true

  get questionsLen(): number {
    return this.questions.length
  }

  closeQuestionCreate() {
    this.editQuestionDlgState = false
    this.qsCurTypeNew = 'text'
  }

  closePostDialog() {
    this.isPostDialog = false
  }

  closeisCommentDialog() {
    this.isCommentDialog = false
  }


  selectedQuestionTitleChanged(title: string): void {
    const index = this.questions.findIndex((v: IQuestion) => v.id === (this.selectedQuestion as IQuestion).id);

    /**
     * Проверка заголовков от ложного срабатывания при выборе вопроса
     */
    if ((this.selectedQuestion as IQuestion).text !== title) {
      this.isChanged = true
    }

    (this.selectedQuestion as IQuestion).text = title
    this.$set(this.questions, index, this.selectedQuestion)
  }

  changeQuestionsFromQBL({oldIndexId, newIndexId}: { oldIndexId: string, newIndexId: string }): void {
    const treeA = this.getFullTree(oldIndexId)
    treeA.sort((a, b) => a.order - b.order)
    const idsA = treeA.map(v => v.id)

    const treeB = this.getFullTree(newIndexId)
    treeB.sort((a, b) => a.order - b.order)
    const idsB = treeB.map(v => v.id)

    const ids = [...idsA, ...idsB]

    const questionWithoutTrees = this.questions
      .filter(v => !ids.includes(v.id))
      .sort((a, b) => a.order - b.order)

    let indexA = questionWithoutTrees.findIndex(v => v.id === oldIndexId)
    let indexB = questionWithoutTrees.findIndex(v => v.id === newIndexId)

    questionWithoutTrees[indexA] = questionWithoutTrees
      .splice(
        indexB,
        1,
        questionWithoutTrees[indexA]
      )[0]

    if (treeA.length) questionWithoutTrees.splice(indexB + 1, 0, ...treeA)
    if (treeB.length) questionWithoutTrees.splice(indexA + 1, 0, ...treeB)

    questionWithoutTrees.forEach((element: any, index: number) => {
      element.order = index + 1
    })

    this.questions = questionWithoutTrees

    this.isChanged = true
  }

  changeAnswersFromQBL(params: IDraggableParamsExtend): void {
    const question = this.questions.find(v => v.id === params.questionId)

    if (question) {
      const answers = question.answers
      const oldIndex = answers.findIndex(v => v.id === params.oldIndexId)
      const newIndex = answers.findIndex(v => v.id === params.newIndexId)

      this.swap(answers, oldIndex, newIndex)
      answers.forEach((element: any, index: number) => {
        element.order = index + 1
      })

      let free = answers.filter(el => el.type === 'free_text_input' || el.type === 'free_number_input')

      if (free.length > 0) {
        answers.splice(answers.indexOf(free[0]), 1)
        free[0].order = answers.length + 1
        answers.push(free[0])
      }

      this.questions = this.questions.map(v => {
        if (v.id === params.questionId) {
          v.answers = answers
        }

        return v
      })


      this.isChanged = true
    }
  }

  swap(arr: any[], a: number, b: number) {
    arr[a] = arr.splice(b, 1, arr[a])[0]
  }

  getFullTree(id: string): IQuestion[] {
    const result: IQuestion[] = []

    this.getChildTree(id, result, true)

    return result
  }

  getChildTree(id: string, resultArray: IQuestion[], isStart: boolean = false) {
    const parent = this.questions.find(v => v.id === id)
    const childrens = this.getIncludeQuestions(id)

    if (childrens.length) {
      childrens.forEach(v => {
        this.getChildTree(v, resultArray)
      })
    }

    if (!isStart) resultArray.push((parent as IQuestion))
  }

  getIncludeQuestions(questionId: string) {
    const question = this.questions.find(v => v.id === questionId)

    return (question as IQuestion).answers
      .reduce((acc: string[], a: IAnswer) => {
        const includeQuestions: string[] = a.includeQuestions || []

        return [...acc, ...includeQuestions]
      }, [])
      .filter(v => !!v)
  }

  getAllAnswersIncludeQuestions(answers: IAnswer[]): string[] {
    return answers.reduce((accumulator: string[], a: IAnswer) => {
      if (a.includeQuestions) {
        return [...accumulator, ...a.includeQuestions]
      }

      return [...accumulator]
    }, [])
  }

  getQuestionsByIncludeQuestions(includeQuestions: string[]): IQuestion[] {
    return this.questions.filter(v => includeQuestions.includes(v.id))
  }

  protected deleteAnswerData: { answerId: string, questionId: string } | null = null
  protected deleteAnswerDialog: boolean = false

  deleteAnswerDialogOpen(data: { answerId: string, questionId: string }): void {
    this.deleteAnswerData = data
    this.deleteAnswerDialog = true
  }

  deleteAnswer(): void {
    const data = this.deleteAnswerData

    if (data) {
      this.questions = this.questions.map(q => {
        if (q.id === data.questionId) {
          const answers = q.answers.filter(v => v.id !== data.answerId)

          q.answers = answers
        }

        return q
      })

      this.deleteAnswerDialog = false
      this.deleteAnswerData = null
      this.isChanged = true
    } else {
      console.error('Can\'t remove answer, cuz deleteAnswerData is null...')
    }
  }

  questionClicked(id: string) {
    const result = this.questions.find(v => v.id === id)

    if (result) {
      this.selectedQuestion = result
    }
  }

  protected questionIdToDelete: string = ''

  removeQuestion() {
    this.selectedQuestion = {}
    this.dltQuestion(this.questionIdToDelete)
    this.isChanged = true
    this.deleteDlgState = false
  }

  deleteQuestion(value: string) {

    this.questionIdToDelete = value
    this.deleteDlgState = true
  }
  deleteComment(value: string) {

    this.questionIdToDelete = value
    this.deleteDlgStateComment = true
  }
  deleteSignature(value: string) {
    this.questionIdToDelete = value
    this.deleteDlgStatePodpis = true
  }

  handleDrag(event: any) {
    this.isChanged = true
    this.questions.forEach((element: IQuestion, index: number) => {
      element.order = index + 1
    })
  }

  protected headers: TableHeaderItem[] = []
  protected isOpenSnackbar: boolean = false

  protected cancelSavingSurvey() {
    this.saveSurveyDlgState = false
    this.isChanged = false
    this.$router.push(this.navigationPath)
  }

  protected survey: Survey | null = null
  protected questions: IQuestion[] = []

  protected addAnswerDlgState: boolean = false
  protected editAnswerTitle: string = ''
  protected editAnswerId: string = ''

  protected TYPE_TEXT = this.$t('survey.types.typeText')
  protected TYPE_SELECT = this.$t('survey.types.typeSelect')
  protected SPECIFY_SINGLE = this.$t('survey.types.specifySingle')
  protected SPECIFY_MULTI = this.$t('survey.types.specifyMulti')

  protected isChanged: boolean = false
  protected editQuestionDlgState: boolean = false

  protected qsId: string = ''
  protected qsCurTitle: string = ''
  protected qsSpecifyListNew: any = [
    {id: 'text', text: this.$t('survey.data.text')},
    {id: 'number', text: this.$t('survey.data.number')}
  ]
  protected qsSpecifyLisSelectNew: any = [
    {id: 'single', text: this.$t('survey.types.specifySingle')},
    {id: 'multi', text: this.$t('survey.types.specifyMulti')}
  ]
  protected qsCurSpecifyNew: any = 'text'
  protected qsTypeListNew: any = [
    {id: 'text', text: this.$t('survey.types.typeText')},
    {id: 'select', text: this.$t('survey.types.typeSelect')}
  ]
  protected qsCurTypeNew: any = 'text'

  @Watch('qsCurTypeNew')
  changeSelectDefault(val: any) {
    if (val) {
      if (val === 'text') {
        this.qsCurSpecifyNew = 'text'
      }
      if (val === 'select') {
        this.qsCurSpecifyNew = 'single'
      }
    }
  }


  protected qsSpecifyList: TranslateResult[] = [this.SPECIFY_SINGLE, this.SPECIFY_MULTI]
  protected qsCurSpecify: TranslateResult = this.SPECIFY_SINGLE
  protected qsTypeList: TranslateResult[] = [this.TYPE_TEXT, this.TYPE_SELECT]
  protected qsCurType: TranslateResult = this.TYPE_SELECT
  protected qsErrorFields: any = []
  protected saveSurveyDlgState: boolean = false
  protected qsAnswerHeaders: TableHeaderItem[] = [
    {
      value: 'title',
      text: this.$t('survey.types.specifyMulti')
    }
  ]
  protected qsAnswers: IAnswer[] = []

  @auth.State('exhibitorId') protected _exhibitor: any

  protected saveQuestionFromBox(question: any) {
    const {id} = question
    const questionIndex = this.questions.findIndex(qs => qs.id === id)

    this.$set(this.questions, questionIndex, question)
  }

  protected openAnswerAdd() {
    this.editAnswerId = ''
    this.editAnswerTitle = ''
    this.addAnswerDlgState = true
  }

  protected openAnswerEdit(answer: TableItem) {
    this.editAnswerId = answer.id
    this.editAnswerTitle = answer.title
    this.addAnswerDlgState = true
  }

  protected saveAnswer() {
    this.addAnswerDlgState = false

    if (this.editAnswerId !== '') {
      let answer = this.qsAnswers.filter(
        (ans: IAnswer) => ans.id == this.editAnswerId
      )[0]

      answer.value = this.editAnswerTitle

      this.qsAnswers = this.qsAnswers.filter(
        (ans: IAnswer) => ans.id != this.editAnswerId
      )
      this.qsAnswers.push(answer)
    } else {
      this.qsAnswers.push({
        id: (uuid.v1() as string),
        sense: (this.$moment().format('X') as string),
        order: Number(this.$moment().format('X')),
        value: (this.editAnswerTitle as string),
        type: 'regular'

      })
    }

    let params = [
      {
        "name": "“Анкета”: Действие “Добавить ответ”, сохранено",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
    this.editAnswerTitle = ''
  }

  protected dropAnswer(answer: TableItem) {
    this.qsAnswers = this.qsAnswers.filter(
      (ans: IAnswer) => ans.id != answer.id
    );
  }

  protected get tableAnswers(): TableItem[] {
    return this.qsAnswers
      .sort(function (a: IAnswer, b: IAnswer) {
        return a.value > b.value ? 1 : a.value < b.value ? -1 : 0
      })
      .map((answer: IAnswer) => {
        return {
          id: answer.id,
          title: answer.value
        }
      })
  }

  protected get tableQuestions(): TableItem[] {
    if (this.questions.length == 0) return []

    return this.questions
      .sort(function (a: IQuestion, b: IQuestion) {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
      })
      .map((qs: IQuestion) => {
        return {
          id: qs.id,
          title: qs.text,
          answersCount: qs.type === 'text' ? '-' : String(qs.answers.length),
          type: qs.type === 'select' || qs.type === 'catalog' ? 'Выбор' : 'Текст'
        }
      })
  }

  protected openEditQuestion(tableQuestion: IQuestion) {
    let question: IQuestion = this.questions.filter(
      (qs: IQuestion) => qs.id == tableQuestion.id
    )[0]

    this.qsId = question.id
    this.qsCurTitle = question.text
    this.important = question.important
    this.qsCurSpecify =
      question.specify === 'single' ? this.SPECIFY_SINGLE : this.SPECIFY_MULTI
    this.qsCurType =
      question.type === 'select' || question.type == 'catalog'
        ? this.TYPE_SELECT
        : this.TYPE_TEXT
    this.qsAnswers = question.answers
    this.editQuestionDlgState = true
  }

  protected openCreateQuestion() {
    this.qsId = ''
    this.qsCurTitle = ''
    this.important = false
    this.checkFree = false
    this.checkFreeType = 'free_text_input'
    this.editAnswerTitle = ''
    this.qsCurSpecify = this.SPECIFY_SINGLE
    this.qsCurType = this.TYPE_TEXT
    this.qsAnswers = []
    this.editQuestionDlgState = true
  }

  protected dropQuestion(questionId: string) {
    // if (this.survey === null) return


    this.deleteDlgState = false
    this.deleteDlgStatePodpis = false
    this.deleteDlgStateComment = false
    this.questions = this.questions.filter((qs: IQuestion) => qs.id != questionId)
    this.questions.forEach((v: IQuestion, index: number) => {
      if(v.order !== 777777777){
        v.order = index + 1
      }
    })
    this.selectedQuestion = {}
    this.isChanged = true
    let params = [
      {
        "name": "“Анкета”: Действие “Удалить вопрос”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  protected saveQuestion(type:number  ) {
    if (this.survey === null) return

    this.editQuestionDlgState = false


    let question: IQuestion = this.qsId != ''
      ? this.questions.filter((qs: IQuestion) => qs.id === this.qsId)[0]
      : {
        id: uuid.v1(),
        text: '',
        specify: '',
        type: '',
        answers: [],
        answerTitle: '',
        help: '',
        important: false,
        order: this.questions.length + 1
      }


    if(type === 1){
      question.text = this.qsCurTitle
      question.type = this.qsCurTypeNew
      question.specify = this.qsCurSpecifyNew
      question.important = this.important
      question.answers =
        question.type === 'text'
          ? [
            {
              id: uuid.v1(),
              sense: this.$moment().format('X'),
              order: Number(this.$moment().format('X')),
              value: '',
              type: 'regular'
            }
          ]
          : this.qsAnswers

      if (this.checkFree) {
        question.answers.push({
          id: uuid.v1(),
          sense: (this.$moment().format('X') as string),
          order: question.answers.length + 1,
          value: '',
          type: this.checkFreeType
        })
      }
      let params = [
        {
          "name": "“Анкета”: Действие “Добавить вопрос”, добавлено",
          "data": {
            "company": this.userCompany.title
          }
        }
      ]
      this.sendEvent(params)
    }
    // post
    if(type === 2){
      question.help = this.PostModel.text
      question.text = this.PostModel.title
      question.type = 'text_container'
      question.order = 777777777
    }

    //comment
    if(type === 3){
      question.help = this.CommentModel.text
      question.text = this.CommentModel.title
      question.type = 'text_container'
    }



    if (question.type === 'text') {
      question.answerTitle = this.$t('survey.enterText')
    } else if (
      (question.type === 'catalog' || question.type == 'select') &&
      question.specify === 'single'
    ) {
      question.answerTitle = this.$t('survey.chooseOneAnswer')
    } else if (
      (question.type === 'catalog' || question.type === 'select') &&
      question.specify === 'multi'
    ) {
      question.answerTitle = this.$t('survey.chooseMultiAnswer')
    }
    else {
      question.answerTitle = ''
    }



    if (question.type === 'text_container')  question.type = 'text_comment'
    if(question.type === 'text_comment' && question.order === 777777777) question.type = 'text_post'

    this.questions = this.questions.filter(
      (qs: IQuestion) => qs.id != this.qsId
    )
    this.questions.push(question)

    this.isChanged = true
    this.qsCurTypeNew = 'text'
  }

  protected deleteDlgState: boolean = false
  protected deleteDlgStatePodpis: boolean = false
  protected deleteDlgStateComment: boolean = false

  protected isIncludeQuestionsEmpty(includeQuestions: string[]) {
    return !includeQuestions || !includeQuestions[0]
  }

  protected getQueryAnswers(answers: IAnswer[]) {

    let response = answers

    return response.map((answer: IAnswer) => {
      let result: any = '[]'
      if (answer.includeQuestions && !this.isIncludeQuestionsEmpty(answer.includeQuestions)) {
        const formattedIncQs = answer.includeQuestions.map(v => `\\"${v}\\"`)
        result = `[${formattedIncQs}]`
      }
      let valueIn = answer.value.replace(/"/g,"'")
      return `{
          id: \\"${answer.id}\\",
          sense: \\"${answer.sense}\\",
          type: \\"${answer.type}\\",
          order: ${answer.order},
          value: \\"${valueIn}\\",
          includeQuestions: ${result},
        }`
    })
      .join(',')

  }

  preventNav(event: any) {
    if (!this.isChanged) return

    this.saveSurveyDlgState = true
    event.preventDefault()
    event.returnValue = ''
  }

  protected getQueryQuestions() {
    let que = JSON.parse(JSON.stringify(this.questions))
    return que
      .sort(function (a: IQuestion, b: IQuestion) {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
      })
      .map((qs: IQuestion) => {
        if (qs.type === 'text_comment') {
          qs.type = 'text_container'
        }
        if (qs.type === 'text_post') {
          qs.type = 'text_container'
          qs.order = 777777777
        }
        let helpIn = qs.help.replace(/"/g,"'").split('\n').join('\\\\n')
        let textIn = qs.text.replace(/"/g,"'")
        return `{
          answerTitle: \\"${qs.answerTitle}\\",
          help: \\"${helpIn}\\",
          id: \\"${qs.id}\\",
          important: ${qs.important},
          order: ${qs.order},
          specify: \\"${qs.specify}\\",
          text: \\"${textIn}\\"
          type: \\"${qs.type}\\",
          answers: [${this.getQueryAnswers(qs.answers)}]
        }`
      })
      .join(',')
    // // console.log(res)

  }
  // protected getQueryQuestions() {
  //   return this.questions
  //     .sort(function(a: IQuestion, b: IQuestion) {
  //       return a.order > b.order ? 1 : a.order < b.order ? -1 : 0
  //     })
  //     .map((qs: IQuestion) => {
  //       return `{
  //         answerTitle: \\"${qs.answerTitle}\\",
  //         help: \\"\\",
  //         id: \\"${qs.id}\\",
  //         important: ${qs.important},
  //         order: ${qs.order},
  //         specify: \\"${qs.specify}\\",
  //         text: \\"${qs.text}\\",
  //         type: \\"${qs.type}\\",
  //         answers: [${this.getQueryAnswers(qs.answers)}]
  //       }`
  //     })
  //     .join(',')
  // }


  protected saveSurvey() {

    if (this.survey === null) return
    let QueryQuestions = this.getQueryQuestions()
    let hasSignature = false
    if (this.questions.filter(el => el.type === 'text_post').length > 0) hasSignature = true

    Vue.axios({
      url: '/query',
      method: 'POST',
      data: `
        {
          "query": "mutation {
            Survey (
              _id: \\"${this.survey._id}\\"
              hasSignature: ${hasSignature}
              questions : [${QueryQuestions}]
            ) {
              _id
            }
          }"
        }
      `,
    })
      .then((resp: any) => {

        if (resp.data.status == 'ok') {
          console.log('bbom')
          this.isOpenSnackbar = true
          this.isChanged = false
          // if (this.navigationPath != '') {
          //   this.$router.push(this.navigationPath)
          // }
          // this.questions = this.setSurvey(resp)

          let params = [
            {
              "name": "“Анкета”: Действие “Изменить настройки к действующим вопросам”, сохранено",
              "data": {
                "company": this.userCompany.title
              }
            }
          ]
          this.sendEvent(params)
        }
      })
      .catch((err: any) => {

      })
  }

  protected branchQuestions(data: IQuestionBranchData): void {

    const ids = data.includeQuestions
    let splicedQuestionArray: IQuestion[] = []

    for (let i = 0; i < ids.length; i++) {
      const tree = this.getFullTree(ids[i]).sort((a, b) => a.order - b.order)
      const treeOrigin: IQuestion = (this.questions.find(v => v.id === ids[i]) as IQuestion)

      tree.unshift(treeOrigin)
      splicedQuestionArray.push(...tree)
    }

    /**
     * Удаляем дочерние элементы из this.questions,
     * чтобы вставить их после вопроса и валидно отсортировать
     */
    const allTreeIds = splicedQuestionArray.map(v => v.id)
    const questionsWithoutChilds = this.questions.filter(v => !allTreeIds.includes(v.id))

    const questionIndexBeforeChildInjection = questionsWithoutChilds.findIndex(v => v.id === data.questionId)
    const result = questionsWithoutChilds

    // console.log('Index', questionIndexBeforeChildInjection)
    // console.log(questionsWithoutChilds.map(v => ({id: v.id, text: v.text, order: v.order })))
    // console.log(splicedQuestionArray.map(v => ({id: v.id, text: v.text, order: v.order })))

    result.splice(questionIndexBeforeChildInjection + 1, 0, ...splicedQuestionArray)

    const questionIndex = result.findIndex(v => v.id === data.questionId)
    const answerIndex = result[questionIndex].answers.findIndex(v => v.id === data.answerId)
    const answerItem = result[questionIndex].answers[answerIndex]

    if (answerItem) {
      answerItem.includeQuestions = data.includeQuestions
      result[questionIndex].answers[answerIndex] = answerItem
    }

    result.forEach((element: any, index: number) => {
      element.order = index + 1
    })

    this.questions = result
    this.isChanged = true
  }

  protected removeQuestionFromBranch(
    data: {
      answerId: string
      questionId: string
      includeId: string
    }
  ): void {
    let questionIndex = 0
    const question = this.questions.find((v: IQuestion, index: number) => {
      const result = v.id === data.questionId

      if (result) questionIndex = index

      return result
    })

    if (question) {
      let answerId = 0
      const answer = question.answers.find((v: IAnswer, index: number) => {
        const result = v.id === data.answerId

        if (result) answerId = index

        return result
      })

      if (answer) {
        const includeQuestions = (answer.includeQuestions as string[]).filter(v => v !== data.includeId)

        answer.includeQuestions = includeQuestions
        question.answers[answerId] = answer
        this.$set(this.questions, questionIndex, question)
        this.isChanged = true
      }
    }
  }

  beforeMount() {

    window.addEventListener('beforeunload', (event) => {
      if (!this.isChanged) return

      event.preventDefault()
      event.returnValue = ''
    })
  }

  async created(): Promise<void> {
    window.addEventListener('click', () => {
      this.dropdownMenuState = false
    })

    EventBus.$on('questionBoxClicked', (id: string) => {
      this.questionClicked(id)
    })

    EventBus.$on('questionBranchSubmited', (data: IQuestionBranchData) => {
      this.branchQuestions(data)
    })

    EventBus.$on('removeQuestionFromBranch', (data: any) => {
      this.removeQuestionFromBranch(data)
    })

    this.headers = [
      {
        value: 'title',
        text: this.$t('survey.headers.title')
      },
      {
        value: 'answersCount',
        text: this.$t('survey.headers.answersCount')
      },
      {
        value: 'type',
        text: this.$t('survey.headers.type')
      }
    ]

    try {

      const req = await this.getSurveys({exhibitor: this._exhibitor})
      this.survey = this.setSurvey(req.surveys[0])
      this.questions = this.setSurvey(req.surveys[0]).questions
      if (this.questions.length === 0) this.openCreateQuestion()
    } catch (error) {
      console.log(error)
    } finally {
      this.pageLoading = false
    }
  }

  protected setSurvey(surveys: any) {
    surveys.questions.map((elem: any) => {
      if (elem.type === 'text_container' && elem.order === 777777777) {
        elem.type = 'text_post'
      }
      if (elem.type === 'text_container') {
        elem.type = 'text_comment'
      }
      return elem
    })
    return surveys
  }

  get widgetDisable(){
    return Boolean(this.questions.filter(el=>el.type==='text_post').length)
  }


  protected PostModel: PostModel = {
    text: '',
    title:''
  }
  protected CommentModel: Comment = {
    title: '',
    text: ''
  }

  protected clearModel() {
    this.PostModel = {
      title:'',
      text: ''
    }
    this.CommentModel = {
      title: '',
      text: ''
    }
  }
  savePost() {
    this.saveQuestion(2)
    this.isPostDialog = false
    this.isChanged = true
    this.clearModel()
  }

  saveComment() {
    this.saveQuestion(3)
    this.isCommentDialog = false
    this.isChanged = true
    this.clearModel()
  }

  change(item: boolean) {
    item = !item;
  }


  beforeDestroyed() {
    EventBus.$off('questionBoxClicked')

    EventBus.$off('questionBranchSubmited')

    EventBus.$off('removeQuestionFromBranch')
  }

  beforeRouteLeave(to: RawLocation, from: RawLocation, next: NavigationGuardNext) {
    if (this.isChanged && !this.isChangedDialog) {
      this.isChangedDialog = true
      this.routeReserve = to
    } else {
      next()
    }
  }

  protected isChangedDialog: boolean = false
  protected isPostDialog: boolean = false
  protected isCommentDialog: boolean = false
  protected routeReserve: RawLocation | null = null

  protected async updateSurveyBeforeRouteNext(save: boolean = true) {
    if (save) await this.saveSurvey()

    if (this.routeReserve) {
      this.$router.push(this.routeReserve)
    }
  }
}
